import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllvalueAdditionTwoResponse, ValueAdditionIdModel, valueAdditionIdResponse, ValueAdditionTwoDto, valueAdditionTwoResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAddTwoTypeAdapter } from './dto/value-addition-two.adapter';
import { ValueAdditionTwoDTO } from './dto/value-addition-two.dto';
import { ValueAdditionTwoRequest } from './dto/value-addition-two.request';
import { ValueAdditionTwoType } from './value-addition-two.entity';

@Injectable()
export class ValueAddition2TypesService {
    constructor(
      private logService:LogsService,
        @InjectRepository(ValueAdditionTwoType) private foodTypeRepository: Repository<ValueAdditionTwoType>,
        private valAddTwoAdapter: ValueAddTwoTypeAdapter,
      ) { }

    //create method
      async createValAddTwoType(valAddDto:ValueAdditionTwoDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionTwoResponse> {
        try {
        let previousValue
        if (!isUpdate) {
            const valAddTwoTypeEntity = await this.getValAddTwoType(valAddDto.code);
          if (valAddTwoTypeEntity) {
            throw new valueAdditionTwoResponse(false,11104, 'Value Addition Type already exists');
          }
        }
        else {
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{valueAdditionTwoId:valAddDto.valueAdditionTwoId}})
            previousValue = certificatePrevious.name+" , "+certificatePrevious.code;
            const valAddTwoTypeEntity = await this.getValAddTwoType(valAddDto.code);
          if (valAddTwoTypeEntity) {
            if(valAddTwoTypeEntity.valueAdditionTwoId!=valAddDto.valueAdditionTwoId){
                throw new valueAdditionTwoResponse(false,11104, 'Value Addition Type already exists');
            }
          }
        }
        const convertedvalAddTypeEntity: ValueAdditionTwoType = this.valAddTwoAdapter.convertDtoToEntity(valAddDto,isUpdate);
        const savedValAddEntity: ValueAdditionTwoType = await this.foodTypeRepository.save(convertedvalAddTypeEntity);
        const savedValAddTypeDto: ValueAdditionTwoDTO = this.valAddTwoAdapter.convertEntityToDto(savedValAddEntity);
       
         if (savedValAddTypeDto) {
            const present = savedValAddEntity.code+' , '+savedValAddEntity.name
          const response = new valueAdditionTwoResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Value Addition Two Type Updated Successfully':'Value addition Two Type Created Successfully',savedValAddTypeDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Value Addition Two Updated Successfully': 'Value Addition Two Created Successfully'
            const userName = isUpdate? savedValAddTypeDto.updatedUser :savedValAddTypeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'ValueAdditionTwoDTO', savedValAddTypeDto.valueAdditionTwoId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new valueAdditionTwoResponse(false,11106,'Value Addition Two Type saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
        async getAllValAddTwoTypes(req?:UserRequestDto): Promise<AllvalueAdditionTwoResponse> {  
            try {
                const valAddDto: ValueAdditionTwoDto[] = [];
                // retrieves all plants
                const valAddOneTypeEntities: ValueAdditionTwoType[] = await this.foodTypeRepository.find({
                    order: { name: "ASC" },
                });
                //   console.log(valAddOneTypeEntities);
                if (valAddOneTypeEntities.length>0) {
                    valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionTwoDto = this.valAddTwoAdapter.convertEntityToDto(valAddOneTypeEntity);
                    valAddDto.push(convertedValAddTypeDto);
                    });
                    const response = new AllvalueAdditionTwoResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                    if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'ValueAdditionTwoDTO', 0, true, 'Value Addition Types retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                    }
                    return response;
                } else {
                      console.log('yest')
                    throw new valueAdditionTwoResponse(false,99998, 'No Records Found');
                }
        } catch (err) {
        throw err;
        }
    }

     /**
     * gets all  val addition two types details  
     * @returns all the val addition two type details .
     */
    // @LogActions({ isAsync: true })
    async getAllActiveValAddTwoTypes(): Promise<AllvalueAdditionTwoResponse> {  
        try {
            const valAddDto: ValueAdditionTwoDto[] = [];
            // retrieves all plants
            const valAddOneTypeEntities: ValueAdditionTwoType[] = await this.foodTypeRepository.find({
                where:{isActive:true},order: { name: "ASC" },
            });
            //   console.log(valAddOneTypeEntities);
            if (valAddOneTypeEntities.length>0) {
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                const convertedValAddTypeDto: ValueAdditionTwoDto = this.valAddTwoAdapter.convertEntityToDto(valAddOneTypeEntity);
                valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionTwoResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                return response;
            } else {
                  console.log('yest')
                throw new valueAdditionTwoResponse(false,99998, 'No Records Found');
            }
    } catch (err) {
    throw err;
    }
}

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    //  @LogActions({isAsync: true})
     async activateOrDeactivateValAddTwoType(valAddOneReq: ValueAdditionTwoRequest): Promise<valueAdditionTwoResponse> {
         try {
             const FoodTypeExists = await this.getValAddTypeById(valAddOneReq.valueAdditionTwoId);
             if (FoodTypeExists) {
                 if (valAddOneReq.versionFlag !== FoodTypeExists.versionFlag) {
                     throw new valueAdditionTwoResponse(false,10113, 'Someone updated the current Value Addition information.Refresh and try again');
                 } else {
                     
                         const foodTypeSatatus =  await this.foodTypeRepository.update(
                             { valueAdditionTwoId: valAddOneReq.valueAdditionTwoId },
                             { isActive: valAddOneReq.isActive,updatedUser: valAddOneReq.updatedUser });
                        
                         if (FoodTypeExists.isActive) {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionTwoResponse = new valueAdditionTwoResponse(true, 10115, 'Value Addition Type is de-activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionTwoResponse(false,10111, 'Value Addition Type is already deactivated');
                             }
                         } else {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionTwoResponse = new valueAdditionTwoResponse(true, 10114, 'Value addition type is activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionTwoResponse(false,10112, 'Value addition type is already  activated');
                             }
                         }
                     // }
                 }
             } else {
                 throw new valueAdditionTwoResponse(false,99998, 'No Records Found');
             }
         } catch (err) {
             throw err;
         }
     }

    async getValAddTwoType(valAddTwoCode: string): Promise<ValueAdditionTwoType> {
    //  console.log(employeeId);
        const response = await this.foodTypeRepository.findOne({
        where: {code: valAddTwoCode},
        });
        // console.log(response);
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    

    async getValAddTypeById(valueAdditionId: number): Promise<ValueAdditionTwoType> {
        //  console.log(employeeId);
            const Response = await this.foodTypeRepository.findOne({
            where: {valueAdditionTwoId: valueAdditionId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     */
    async getValAddDetails(valueAdditionId: number): Promise<valueAdditionIdResponse> {
        const valAddData = await this.foodTypeRepository.findOne({select: ['name','code'], where: {valueAdditionTwoId: valueAdditionId}});
        if(valAddData) {
            const modelResponse = new ValueAdditionIdModel(valAddData.name, valAddData.code);
            const response = new valueAdditionIdResponse(true, 11208, "Value Addition Types retrieved successfully", modelResponse);
            return response;
        } else {
            return null;
        }   
    }    
}
